import { PdfAnnotationSubtype } from "@paperviewpdf/models";

/**
 * Shapes: annotations drawn with Paperview PDF's shape tools (rectangle,
 * circle, line, arrow, polygon, polyline, pen). They are told apart from
 * text markup (highlight, strikeout...) and from pin drops (stamps).
 */

var SHAPE_ANNOTATION_TYPES = [
  PdfAnnotationSubtype.LINE,
  PdfAnnotationSubtype.SQUARE,
  PdfAnnotationSubtype.CIRCLE,
  PdfAnnotationSubtype.POLYGON,
  PdfAnnotationSubtype.POLYLINE,
  PdfAnnotationSubtype.INK,
];

/**
 * Tells whether an annotation type is a shape.
 *
 * @param {number} type - a PdfAnnotationSubtype value
 * @returns {boolean}
 */
export function isShapeAnnotationType(type) {
  return SHAPE_ANNOTATION_TYPES.indexOf(type) !== -1;
}

/**
 * Tells whether an annotation is a shape.
 *
 * @param {Object} annotation - annotation object from the annotation plugin
 * @returns {boolean}
 */
export function isShapeAnnotation(annotation) {
  if (!annotation) return false;
  return isShapeAnnotationType(annotation.type);
}
